export enum PaymentType {
  NOT_AVAILABLE = "N/A",
  NOT_ON_FILE = "Not on File",
  LUMPSUM = "Lump Sum",
  INSTALLMENT = "Installment",
  INITIAL = "Initial",
  CUSTOM_METHOD = "Custom method",
  LUMP_ROLL = "Lump w/ rollover",
}
